<template>
  <div class="comp-fh-main-table-group">
    <template v-if="viewsObj?.viewClass == '30'">
      <fh-board-view ref="boardRef" :groupFieldInfo="viewsObj?.groupInfo?.[0]" v-if="data.columns?.length" :fieldList="data.fieldList" @getComputedStatus="getComputedStatus" @loadGroupData="loadGroupData" @loadMoreGroupData="loadMoreGroupData" @toDetails="toDetails" @refreshList="refreshList" @shortcutBtnCb="shortcutBtnCb" :viewId="data.viewId" :entityId="entity" :businessData="viewsObj?.businessData" :height="maxHeight" :groupInfo="newGroupInfo" :tableData="tableData" :buttonUniversalAdd="buttonUniversalAdd" :shortcutBtnPermission="shortcutBtnPermission" :loading="data.loading" />
    </template>
    <template v-else>
      <fh-table v-if="data.columns?.length" :columns="data.columns" ref="fhTableRef" :data="tableData" :viewId="data.viewId" :bordered="false" :loading="data.loading && isInitLoad" :showColOverlay="data.showColOverlay" :filterFieldArray="filterFieldArray" :maxHeight="maxHeight" @headerIconMore="headerIconMore" v-model:activeRowKeys="activeRowKeys" :isChecked="true" checkBoxClassName="checkbox-custom-class" :errorRowList="errorRowList" :groupInfo="newGroupInfo" :summary="hasSummary" activeRowType="single" @columnResize="columnResize" @loadGroupData="loadGroupData" :checkedParams="{ width: aiSummaryOptions.enabled ? 104 : 72, checked: selectTableIds }" :cornerMark="true">
        <template #empty>
          <jw-empty :img-src="noDataSvg" :description="props.buttonUniversalAdd ? '暂无数据，你可以点击下方按钮新建数据' : noGroupTipMsg || $t('暂无数据')"></jw-empty>
          <jw-button v-if="props.buttonUniversalAdd" @click="addRow" type="outline" :style="{ minWidth: '100px', cursor: 'pointer' }" size="medium">{{ props.buttonUniversalAdd.label }}</jw-button>
        </template>

        <!-- 错误角标 -->
        <template #cornerMark="{ row }">
          <template v-if="row?.computedInfo?.status == 2">
            <ly-computed-icon-tips :computedInfo="row?.computedInfo" />
          </template>
        </template>

        <!-- 自定义复选框 -->
        <template #customCheckbox="{ row, index }">
          <!-- 数据下标 -->
          <div v-if="!computingStatus.includes(row?.computedInfo?.status)" :class="['index-num', selectTableIds.includes(row.id) ? 'index-num-hide' : 'index-num-show']">{{ index + 1 }}</div>

          <div class="checkbox-container">
            <div class="computed-status-container" v-if="computingStatus.includes(row?.computedInfo?.status)">
              <jw-tooltip :content="row?.computedInfo?.status === 1 ? '计算处理中' : '审批处理中'">
                <icon-refresh class="computed-status-icon" :size="16" style="color: rgb(var(--primary-6))" spin @click="getComputedStatus([row.id])" />
              </jw-tooltip>
            </div>

            <div v-if="!computingStatus.includes(row?.computedInfo?.status)" :class="['index-handle-box', selectTableIds.includes(row.id) ? 'index-handle-box-show' : 'index-handle-box-hide']">
              <jw-checkbox class="show-index-checkbox" :model-value="selectTableIds.includes(row.id)" :disabled="!row.hasData" @change="selectSingle($event, row)"></jw-checkbox>
            </div>

            <jw-tooltip content="查看详情">
              <div class="index-detail-icon" @click.stop="toDetails(row)">
                <qfei-icon-full-screen-outlined />
              </div>
            </jw-tooltip>

            <jw-tooltip v-if="aiSummaryOptions.enabled" :content="$t('AI总结汇总')">
              <div class="index-ai-icon" :data-id="row.id" @click="aiSummaryOptions.setActiveData(row)">
                <img :src="aiIcon" :alt="$t('AI总结汇总')" />
              </div>
            </jw-tooltip>
          </div>
        </template>
        <!-- 自定义标题复选框 -->
        <template #customTitleCheckbox>
          <span></span>
        </template>
        <!-- 分组标题 插槽 -->
        <template #group-table-title="{ row }">
          <jw-checkbox v-if="groupCount === row.level" :model-value="groupChecked[row.groupKey]?.checked" class="group-checkbox" :indeterminate="groupChecked[row.groupKey]?.indeterminate" :disabled="groupChecked[row.groupKey]?.disabled" @change="selectGroup($event, row)"></jw-checkbox>
          <div class="group-title-name">
            <jw-tag v-if="tools.getStrLen(getDisplayName(row)) < 21" :color="row.bgcolor" size="small" :style="{ color: row.textcolor ? row.textcolor : 'black' }" class="group-title-text">
              {{ getDisplayName(row) }}
            </jw-tag>
            <jw-tooltip v-else :content="getDisplayName(row)">
              <jw-tag :color="row.bgcolor" size="small" :style="{ color: row.textcolor ? row.textcolor : 'black' }" class="group-title-text"> {{ getDisplayName(row) }} </jw-tag>
            </jw-tooltip>
            <span>共</span>
            <div class="group-title-count">{{ row.count }}</div>
            <span>条</span>
          </div>
        </template>
        <!-- 字段图标 改名：headerCellPrefix  -->
        <template #prefix="{ col }">
          <component :is="getFieldIcn(col)" />
        </template>
        <!-- 查看详情 -->

        <!-- 筛选Icon -->
        <template #extraHeader="{ colKey, sort }">
          <template v-if="filterFieldArray.includes(colKey) || typeof sort === 'boolean'">
            <qfei-icon-filter-outlined v-if="typeof sort !== 'boolean'" />
            <qfei-icon-filter-asc-outlined v-else-if="sort === true" />
            <qfei-icon-filter-desc-outlined v-else />
          </template>
          <template v-else>
            <qfei-icon-ascending-order-outlined v-if="sort === true" />
            <qfei-icon-descending-order-outlined v-else />
          </template>
        </template>
        <template #load-more-group-data="{ loadMoreInfo }">
          <div class="load-more-group">
            <qfei-icon-refresh-outlined spin v-if="clickMoreLoading" />
            <div class="load-more-group-data" :class="{ 'load-more-group-data-disabled': clickMoreLoading }" @click.stop="loadMoreGroupData(loadMoreInfo)">{{ clickMoreLoading ? '加载中' : '加载更多' }}</div>
          </div>
        </template>
        <template #groupFoldOrUnfold>
          <div class="group-fold-or-unfold-container" v-if="!groupStructureLoading && groupApiNumber < 1000">
            <div class="fold-or-unfold" @click="foldOrUnfold(true)">
              <qfei-icon-caret-down-outlined />
              <span class="unfold-text">展开</span>
            </div>
            <div class="fold-or-unfold" @click="foldOrUnfold(false)">
              <qfei-icon-caret-up-outlined />
              <span class="unfold-text">收起</span>
            </div>
          </div>
        </template>
      </fh-table>
      <fh-list-skeleton v-else />
    </template>
    <!--主对象公共详情  S-->
    <ly-detail ref="detailRef" @cb="refreshList('detail')" />
    <div v-if="data.showColOverlay" class="overlay" @mousedown.stop="handleMouseDown" @mouseup.stop="handleMouseUp">
      <fh-table-header-more ref="qfTableHeaderMoreRef" @mousedown.stop @mouseup.stop :headerColInfo="headerColInfo" :isSubForm="isIconSubForm" :column="headerColumn" :viewId="data.viewId" :ruleForm="data.ruleForm" @colTitleFrozen="colTitleFrozen" @sortChange="sortChange" @getConditionParams="getConditionParams" />
    </div>
    <div class="batch-shortcut-btn" v-if="shouldShowButtonGroup" :style="{ bottom: hasSummary ? '115px' : '80px' }">
      <fh-shortcut-batch :entity="entity" :viewId="data.viewId" :tableSelectIds="selectTableIds" :tableDataLength="tableDataLength" :showShortcutBtn="shouldShowShortcutBtn" :showBatchBtn="shouldShowBatchBtn" :tableRow="tableRow" :columnFieldList="data.fieldList" :shortcutBtnPermission="shortcutBtnPermission" :batchBtnPermission="batchBtnPermission" :bingDataList="bingDataList" @clearSelected="clearSelected" @shortcutBtnCb="shortcutBtnCb" @batchBtnCb="batchBtnCb" />
    </div>
  </div>
</template>

<script setup>
import { reactive, ref, onMounted, provide, computed, watch, nextTick, onUnmounted, onBeforeUnmount, inject } from 'vue';
import { setService, tableService } from '@/api/';
import { tools } from '@/utils/tools';
import { useUserStore, useLayoutStore, useFilterListStore, useMainTableStore } from '@/store';
import { bingOrgId, permissionsObjList, computingStatus } from '@/utils/const';
import { useI18n } from 'vue-i18n';
import { cloneDeep } from 'lodash';
// 组件引入
import FhTable from '../fh-table/fh-table.vue';
import FhTableHeaderMore from '../fh-table-header-more/fh-table-header-more.vue';
import fhShortcutBatch from '../fh-shortcut-batch/fh-shortcut-batch.vue';
import FhListSkeleton from '@/components/fh-list/fh-list-skeleton/fh-list-skeleton.vue';
import noDataSvg from '@/assets/images/no-data-150.svg';
import { QfeiIconFilterAscOutlined, QfeiIconFilterDescOutlined, QfeiIconFilterOutlined, QfeiIconDescendingOrderOutlined, QfeiIconAscendingOrderOutlined, QfeiIconCaretUpOutlined, QfeiIconCaretDownOutlined, QfeiIconFullScreenOutlined, QfeiIconRefreshOutlined } from '@qfei-design/icons-vue';
// hooks引入
import useFields from '@/hooks/fields';
import useTableColumns from '@/hooks/table-columns';
import FhBoardView from '@/components/fh-list/fh-board-view/fh-board-view.vue'; // 新增：引入自定义 hooks
import aiIcon from '@/assets/images/ai/ai-icon.svg';
import { useLyTableConfig } from '@/hooks/ly-table-config';

const { createChildColumns, createColumnConfig, extractFields } = useTableColumns();
// 使用store
const useTableInfo = useMainTableStore();
const useLayout = useLayoutStore(); //视图及布局store
const useFilterList = useFilterListStore(); // 筛选条件store
// import { tableData1, tableData2, tableData3 } from '@/utils/table-data'; //制造分组测试数据
const props = defineProps({
  entityId: {
    //对象的entity【必传】
    type: Number || String,
    default: undefined
  },
  viewId: {
    type: Number || String,
    default: undefined
  },
  record: {
    type: Object,
    default: () => ({})
  },
  customerId: {
    type: Number || String
  },
  maxHeight: {
    type: Number,
    default: 0
  },
  conditionsType: {
    type: Object,
    default: () => {}
  },
  allFieldsList: {
    type: Array,
    default: () => []
  },
  allFieldsListObj: {
    type: Object,
    default: () => {}
  },
  viewsObj: {
    type: Object,
    default: () => {}
  },
  shortcutBtnPermission: {
    type: Array,
    default: () => []
  },
  batchBtnPermission: {
    type: Array,
    default: () => []
  },
  groupInfo: {
    type: Array,
    default: () => []
  },
  // 新增按钮权限
  buttonUniversalAdd: {
    type: Object,
    default: () => {}
  }
});
// AI汇总
const aiSummaryOptions = inject('aiSummaryOptions', {});
// 是否显示汇总行
const hasSummary = ref(false); //是否显示汇总行
const { userInfo } = useUserStore();
const emits = defineEmits(['cb', 'update:loading', 'loadAdvancedComp', 'cbAdd', 'cbTotalCount']);
const { t } = useI18n();
//类型1-线索 2-客户 3-商机 4-产品 6--报价单详情 7--报价单明细 8 销售合同 9 销售合同明细10销售订单13退货单14退货单产品
const entity = ref(props.entityId);
const fieldsSort = ref([]);
const data = reactive({
  fieldList: [], //获取字段列表所有数据
  loading: true,
  columns: [],
  id: '', //ID、
  record: [],
  leadsID: [],
  viewId: null,
  ruleForm: {
    fieldKey: t('全部数据'), //数据条件
    leadsFieldList: [], //第一个
    objList: {}, //fieldKey：obj 类型
    filterType: {}, //中间
    isGroup: true,
    field: null,
    value: null,
    parentId: undefined,
    conditions: []
  },
  showColOverlay: false, // 父组件弹窗状态
  specialProduct: [7, 9, 11, 14, 32] //特殊产品对象
});
const mouseDownStatus = ref(''); // 鼠标状态
const mouseUpStatus = ref(''); // 鼠标状态
const keywords = ref(''); // 搜索关键字
const searchFieldsList = ref([]); // 搜索字段

const { getNewTableData } = useLyTableConfig(entity.value); // 表格配置hooks

console.log('ly-table-config', getNewTableData);

// 先渲染列表，再调用的字段条件类型接口，所以需要用watch监听
watch(
  () => props.conditionsType,
  (val) => {
    const dr = data.ruleForm;
    dr.filterType = val;
    dr.leadsFieldList = props.allFieldsList;
    dr.objList = props.allFieldsListObj;
  },
  {
    deep: true,
    immediate: true
  }
);

const poolId = ref(); //线索池id
const activeRowKeys = ref([]);
const newGroupInfo = computed(() => props.groupInfo.filter((v) => v.fieldStatus !== 2) || []);
const groupCount = ref(newGroupInfo.value?.length);
const { fieldIconMapping } = useFields(); // 获取字段图标
const getFieldIcn = (field) => {
  return fieldIconMapping.value[Number(field.fieldType)];
};

const boardRef = ref();
const openDashboardFieldSettingModal = () => {
  boardRef.value?.openDashboardFieldSettingModal?.();
};
// 打开列选择
const openColSelect = () => {
  fhTableRef.value?.openColSelect?.();
};
// 查看详情
const toDetails = (record) => {
  console.log('toDetails', record);
  //获取对象entity
  activeRowKeys.value = [record.id];
  console.log(240, record, activeRowKeys.value);
  //特殊产品显示不能点击状态
  if (data.specialProduct.includes(Number(entity.value))) return false;
  data.id = record?.id;
  detailRef.value.openDialog();
};

const getComputedErrorLog = async (businessIdList) => {
  try {
    const json = await setService.getComputedErrorLog({
      entity: entity.value,
      businessIdList: businessIdList
    });
    if (!json.error) {
      return json.result;
    }
  } catch (error) {
    console.log(error);
  }
};
/******************** 嵌套表格 end ***********************/
// const findAssociation = { label: t('属于当前值'), value: 'equals_current_value' };
//兼容自定义
if (entity.value >= 200) {
  permissionsObjList[entity.value] = `${entity.value}:edit`;
}
const detailRef = ref(); //公共抽离组件
// 新增
const addRow = () => {
  const params = { type: 30, viewId: props.viewId, entity: entity.value };
  emits('cbAdd', params);
};
// 是否在飞书环境ss
// const isFeiShuApp = window.h5sdk;
const highFilterParams = ref({}); //高级筛选参数
const tableData = ref([]); //表格数据
const tableRow = ref({}); //当前行数据
const bingDataList = ref([]); //bing特殊逻辑
// 用于存储调用接口前的分组数据(以groupKey为键,以dataIds集合为值的键值对对象)
const groupChecked = ref({}); // 分组选中状态
const checkArrayInclusion = (arr1, arr2) => {
  const set2 = new Set(arr2);
  let includedCount = 0;
  if (arr1?.length === 0) return 3; // 该分组下没有可选行，一个都不包含
  for (const id of arr1) {
    if (set2.has(id)) {
      includedCount++;
    }
  }
  if (includedCount === arr1.length) {
    return 1; // 全包含
  } else if (includedCount === 0) {
    return 3; // 一个都不包含
  } else {
    return 2; // 部分包含
  }
};
// 更新分组全选和半选状态
const updateGroupCheckStatus = (curGroupKey) => {
  const isInclusion = checkArrayInclusion(groupChecked.value[curGroupKey].dataIds, selectTableIds.value);
  const statusMap = {
    1: { checked: true, indeterminate: false },
    2: { checked: false, indeterminate: true },
    3: { checked: false, indeterminate: false }
  };
  Object.assign(groupChecked.value[curGroupKey], statusMap[isInclusion] || {});
  console.log(287, groupChecked.value);
};
// 单选
const selectSingle = (e, row) => {
  const curGroupKey = row?.[`gk${groupCount.value}`];
  console.log(263, row, row.id, curGroupKey, groupChecked.value);
  const newSelectedIds = e ? [...selectTableIds.value, row.id] : selectTableIds.value.filter((v) => v !== row.id);
  selectTableIds.value = newSelectedIds; // 一次性赋值，减少响应式触发
  // 如果仅剩余一套数据时，需要根据剩余ID获取该行数据
  tableRow.value = newSelectedIds.length === 1 ? tableData.value.find((item) => !item.level && item.id === newSelectedIds[0]) : {};
  // 更新当前分组选中状态
  updateGroupCheckStatus(curGroupKey);
  // 目前查询到该数据只有Bing租户的Bing数据同步按钮需要该参数，其他按钮不会用到，考虑根据Bing租户的orgId判断
  if (userInfo.orgId == bingOrgId) {
    getBingDataList();
  }
};
const tableDataLength = computed(() => {
  const allIdsVal = tableData.value.filter((item) => !item.level && item.hasData === true);
  return allIdsVal?.length;
});

const selectGroup = (e, item) => {
  const sIds = [...selectTableIds.value, ...groupChecked.value[item.groupKey].dataIds];
  if (e) {
    // 需要去重，避免重复添加
    selectTableIds.value = Array.from(new Set(sIds));
  } else {
    selectTableIds.value = selectTableIds.value.filter((v) => !groupChecked.value[item.groupKey]?.dataIds.includes(v));
  }
  console.log(307, e);
  const curGroupChecked = groupChecked.value[item.groupKey];
  // 当处于选中状态时取消选中
  if (curGroupChecked.checked) {
    curGroupChecked.checked = false;
  } else {
    // 当处于未选中但不确定状态或完全未选中时设为选中
    curGroupChecked.checked = true;
  }
  // 每次操作后都重置为确定状态
  curGroupChecked.indeterminate = false;
  // 如果仅剩余一条数据时，需要根据剩余ID获取该行数据
  tableRow.value = selectTableIds.value.length === 1 ? tableData.value.find((item) => !item.level && item.id === selectTableIds.value[0]) : {};

  console.log(302302, item.groupKey, groupChecked.value, selectTableIds.value);
};
// bing的特殊逻辑
const getBingDataList = () => {
  // 提前获取必要的值，避免重复访问响应式对象
  const { value: tableDataVal } = tableData;
  const { value: selectTableIdsVal } = selectTableIds;
  const { value: entityVal } = entity;
  // 快速过滤出选中的数据
  const filterList = tableDataVal?.filter((v) => selectTableIdsVal?.includes(v.id)) || [];
  // 使用映射表替代多个 if-else 判断
  const fieldMap = {
    2: 'input_rbKcJb',
    3: 'account_id',
    10: 'id'
  };
  // 检查是否有直接映射的字段
  if (fieldMap[entityVal]) {
    bingDataList.value = filterList.map((v) => v[fieldMap[entityVal]]);
    return;
  }
  // 处理特殊情况
  if (entityVal >= 200 && userInfo?.roles?.includes(`${entityVal}:bingUserInviteSync`)) {
    bingDataList.value = filterList.map((v) => v?.id);
    return;
  }
  // 默认情况
  bingDataList.value = [];
};

/**************************列表初始化获取数据逻辑 S****************************** */
// 在组件中添加 worker 相关状态
const isProcessing = ref(false);
const noGroupTipMsg = ref(null);
const groupApiNumber = ref(0);
const groupStructureLoading = ref(true);
const groupAllStateObj = ref({}); //用于存储所有分组状态
// 默认标签颜色
const colors = ['red', 'orangered', 'orange', 'gold', 'lime', 'green', 'cyan', 'blue', 'arcoblue', 'purple', 'pinkpurple', 'magenta', 'gray'];
let createGroupMap = new Map();
//填充看板选项值
const fillGroupOptions = (_holdTableData) => {
  let holdTableData = cloneDeep(_holdTableData);
  const _viewGroup = props.viewsObj?.groupInfo?.[0];
  //如果不是人员字段并且是看板，需要填充分组项
  if (_viewGroup?.fieldType != 6 && props.viewsObj?.viewClass == '30' && _holdTableData?.length > 0) {
    const _fieldExt = tools.isJSON(_viewGroup?.fieldExt) ? JSON.parse(_viewGroup?.fieldExt) : [];
    if (_fieldExt?.length > 0) {
      const _newHoldTableData = [];
      const _options = _fieldExt.map((item) => item.value);
      _fieldExt?.forEach((ext) => {
        const _findIndex = holdTableData.findIndex((item) => item.value == ext.value);
        if (_findIndex < 0) {
          if (ext?.isEnabled) {
            _newHoldTableData.push({
              business: null,
              count: 0,
              dataIds: [],
              fieldKey: _viewGroup?.fieldKey,
              fieldType: _viewGroup?.fieldType,
              gk1: null,
              gk2: null,
              groupKey: ext?.value,
              groupQuery: null,
              level: 1,
              name: ext?.label
            });
          }
        } else {
          _newHoldTableData.push(holdTableData[_findIndex]);
        }
      });
      //兼容空值
      const _notInOpt = holdTableData.filter((item) => !_options.includes(item.value));
      holdTableData = _newHoldTableData?.concat(_notInOpt || []);
    }
  }

  return holdTableData;
};
// 获取表格数据
const getGroupStructureInfo = async () => {
  try {
    const params = {
      page: 1,
      pageSize: props?.viewsObj?.viewClass == '30' ? 20 : 100,
      id: props.viewId,
      entity: entity.value,
      ...highFilterParams.value,
      ...filterParams.value
    };
    data.loading = true;
    groupStructureLoading.value = true;
    const json = await tableService.getGroupStructureV2(params);
    const holdTableData = fillGroupOptions(json.result);
    console.log(json, holdTableData, 'console.log(json, holdTableData');
    const perfStart = performance.now();
    if (!holdTableData || holdTableData?.length === 0) {
      tableData.value = [];
      data.loading = false;
      emits('update:loading', data.loading);
      noGroupTipMsg.value = '暂无分组';
      isInitLoadData.value = true;
      return;
    }
    groupApiNumber.value = holdTableData.length;
    groupStructureLoading.value = false;
    const shouldUseWorker = typeof Worker !== 'undefined' && holdTableData.length > 50000;
    // 区分使用Web Worker处理还是在主线程处理分组数据
    // 经过测试：3万个分组在WebWorker中处理耗时为500~600ms左右，在主线程中处理耗时为80~150ms左右
    if (shouldUseWorker) {
      await processWithWorker(holdTableData);
      console.log(987654, `在Web Worker中数据处理总耗时: ${performance.now() - perfStart}ms`);
    } else {
      tableData.value = processDataFallback(holdTableData);
      console.log(tableData.value, 'console.log(tableData.value');
      console.log(987654, `在主线程中数据处理总耗时: ${performance.now() - perfStart}ms`);
    }
    // 整理总条数
    const totalCount = holdTableData?.reduce((sum, item) => {
      return item.level === 1 ? sum + (item.count || 0) : sum;
    }, 0);
    emits('cbTotalCount', totalCount);
    data.loading = false; //处理完成就开始渲染表格
    emits('update:loading', data.loading);
  } catch (error) {
    console.error('数据处理错误:', error);
    data.loading = false;
    emits('update:loading', data.loading);
    tableData.value = [];
    isInitLoadData.value = true;
    noGroupTipMsg.value = '数据加载失败';
  }
};

// 在Web Worker中的数据处理逻辑
const processWithWorker = async (holdTableData) => {
  isProcessing.value = true; //设置正在处理中
  let worker = null;
  try {
    //设置超时处理，如果15秒内没有处理完，则使用主线程处理
    const workerTimeout = setTimeout(() => {
      isProcessing.value = false;
      data.loading = false;
      emits('update:loading', data.loading);
      processInChunks(holdTableData);
    }, 15000);

    let workerPath;
    try {
      workerPath = new URL('./group-table-worker.js', import.meta.url).href;
    } catch (e) {
      workerPath = './group-table-worker.js';
    }
    worker = new Worker(workerPath);

    // 确保数据是可序列化的纯对象
    const workerData = {
      groupStructure: JSON.parse(JSON.stringify(holdTableData)), // 深度克隆数组
      groupCount: groupCount.value,
      colors: [...colors], // 克隆数组
      fieldList: JSON.parse(JSON.stringify(newGroupInfo.value)) // 深度克隆对象
    };

    const workerResult = await new Promise((resolve, reject) => {
      worker.onmessage = (e) => {
        clearTimeout(workerTimeout);
        if (e.data.success) {
          resolve(e.data);
        } else {
          reject(new Error(e.data.error));
        }
        worker.terminate();
        worker = null;
      };
      worker.onerror = (error) => {
        clearTimeout(workerTimeout);
        reject(error);
        worker.terminate();
        worker = null;
      };
      worker.postMessage(workerData);
    });

    // 原子性更新数据，避免闪烁
    const update = {
      tableData: workerResult.data,
      groupChecked: workerResult.groupChecked,
      groupAllStateObj: workerResult.groupAllStateObj,
      createGroupMap: new Map(workerResult.createGroupMap)
    };
    // 一次性更新所有状态
    tableData.value = update.tableData;
    groupChecked.value = update.groupChecked;
    groupAllStateObj.value = update.groupAllStateObj;
    createGroupMap = update.createGroupMap;
  } catch (error) {
    console.error('Worker处理失败:', error, tableData.value);
    if (worker) {
      worker.terminate();
      worker = null;
    }
    await processInChunks(holdTableData);
  } finally {
    isProcessing.value = false;
  }
};
// 分块处理大数据
const processInChunks = async (data) => {
  const CHUNK_SIZE = 2000;
  const totalChunks = Math.ceil(data.length / CHUNK_SIZE);
  let result = [];
  for (let i = 0; i < totalChunks; i++) {
    const chunk = data.slice(i * CHUNK_SIZE, (i + 1) * CHUNK_SIZE);
    result = result.concat(processDataFallback(chunk));
    // 每处理完一个分块让出主线程
    if (i < totalChunks - 1) {
      await new Promise((resolve) => tools.requestIdleTask(resolve));
    }
  }
  tableData.value = result;
};
// 生成唯一ID：时间戳 + 随机字符串 + 自增序号
let idCounter = 0;
function generateUniqueId(prefix = '') {
  const timestamp = Date.now().toString(36);
  const randomStr = Math.random().toString(36).slice(-6);
  const counter = (++idCounter).toString(36).padStart(3, '0');
  return `${prefix}${timestamp}-${randomStr}-${counter}`;
}
// 主线程处理函数
const processDataFallback = (groupStructure) => {
  console.log(513, '走到主线程处理了');
  if (!groupStructure?.length) return [];
  const result = [];
  idCounter = 0;
  const newGroupAllStateObj = {};
  const newGroupChecked = {};
  const colorCache = new Map();
  const fieldMap = new Map(newGroupInfo.value.map((item) => [item.fieldKey, item]));
  // 批量处理数据，避免频繁更新响应式对象
  const batchSize = 1000;
  for (let i = 0; i < groupStructure.length; i += batchSize) {
    const batch = groupStructure.slice(i, i + batchSize);
    for (const item of batch) {
      newGroupAllStateObj[item.groupKey] = true;
      const processedItem = assignColorsMainThread(item, fieldMap, colors, colorCache);
      const row = { ...processedItem, _uniqueId: `group-${generateUniqueId()}` };
      result.push(row);
      if (item.level === groupCount.value) {
        createGroupMap.set(item.groupKey, item);
        if (item.dataIds?.length) {
          newGroupChecked[item.groupKey] = {
            checked: false,
            indeterminate: false,
            dataIds: item.dataIds,
            disabled: true
          };
          // 处理子项
          const children = processChildItems(item);
          result.push(...children);
          // 添加加载更多项
          if (item.count > item.dataIds.length) {
            result.push(createLoadMoreItem(item));
          }
        } else if (item.count) {
          // 添加空项
          result.push(createEmptyItem(item));
        }
      }
    }
    // 每处理完一个批次让出主线程
    if (i + batchSize < groupStructure.length) {
      setTimeout(() => {}, 0);
    }
  }
  // 一次性更新响应式对象
  Object.assign(groupAllStateObj.value, newGroupAllStateObj);
  Object.assign(groupChecked.value, newGroupChecked);
  return result;
};
const assignColorsMainThread = (item, fieldMap, colors, colorCache) => {
  if (![2, 4].includes(item.fieldType)) return item;
  const cached = colorCache.get(item.groupKey);
  if (cached) {
    return { ...item, bgcolor: cached.bg, textcolor: cached.text };
  }
  const fieldItem = fieldMap.get(item.fieldKey);
  if (fieldItem?.fieldExt) {
    try {
      const fieldExt = tools.isJSON(fieldItem.fieldExt) ? JSON.parse(fieldItem.fieldExt) : [];
      const match = fieldExt.find((m) => m.label === item.name);
      if (match?.background) {
        colorCache.set(item.groupKey, { bg: match.background, text: match.color });
        return { ...item, bgcolor: match.background, textcolor: match.color };
      }
    } catch (e) {
      console.error('JSON解析错误', e);
    }
  }
  const randomColor = colors[Math.floor(Math.random() * colors.length)];
  colorCache.set(item.groupKey, { bg: randomColor });
  return { ...item, bgcolor: randomColor };
};
// 为dataIds有值的分组行添加占位数据
const processChildItems = (item) => {
  const level = item.level;
  return item.dataIds.map((id, index) => ({
    id,
    gk1: level === 1 ? item.groupKey : item.gk1,
    gk2: level === 2 ? item.groupKey : item.gk2,
    gk3: level === 3 ? item.groupKey : null,
    _uniqueId: `row-${generateUniqueId()}`,
    hasData: false,
    rowIndex: index
  }));
};
// 添加加载更多项
const createLoadMoreItem = (item) => ({
  uniqueMore: item.groupKey,
  groupQuery: item.groupQuery,
  count: item.count,
  page: 1,
  gk1: item.level === 1 ? item.groupKey : item.gk1,
  gk2: item.level === 2 ? item.groupKey : item.gk2,
  gk3: item.level === 3 ? item.groupKey : null,
  _uniqueId: `row-${generateUniqueId()}`,
  hasMore: true
});
// 添加空项
const createEmptyItem = (item) => ({
  groupKey: item.groupKey,
  gk1: item.level === 1 ? item.groupKey : item.gk1,
  gk2: item.level === 2 ? item.groupKey : item.gk2,
  gk3: item.level === 3 ? item.groupKey : null,
  _uniqueId: `row-${generateUniqueId()}`,
  textPlaceholder: '暂无数据',
  isEmpty: true
});

const isInitLoadData = ref(false);
const errorRowList = ref([]); // 存放计算错误的数据id
/**************************列表初始化获取数据逻辑 S****************************** */
const getGroupTableData = async (loadMoreIds) => {
  try {
    const params = {
      entity: entity.value,
      id: data.viewId || props.viewId,
      page: 1,
      pageSize: 200,
      recordIds: loadMoreIds,
      ...highFilterParams.value,
      ...filterParams.value
    };
    // 声明一个数组，用于存储行信息中存在computeInfo的行信息
    const computeInfoRows = [];
    const json = await tableService.getTableDataListPageV2(params);
    const records = json?.result?.records || [];
    const recordMap = new Map(records.map((r) => [r.id, r]));
    const idsToRemove = new Set();
    // 标记需要移除的ID
    for (const id of loadMoreIds) {
      if (!recordMap.has(id)) idsToRemove.add(id);
    }
    // 使用映射优化数据处理
    const newTableData = [];
    const currentData = tableData.value;
    for (let i = 0; i < currentData.length; i++) {
      const item = currentData[i];
      if (item.level) {
        newTableData.push(item);
        continue;
      }
      if (idsToRemove.has(item.id)) {
        newTableData.push(createPlaceholder(item));
        continue;
      }
      const record = recordMap.get(item.id);
      const mergedItem = record ? { ...item, ...record, hasData: true } : item;
      // 检查是否有computedInfo且不为空
      const mc = mergedItem.computedInfo;
      if (mc) {
        if (computingStatus.includes(mc.status)) {
          computeInfoRows.push(mergedItem);
        } else {
          // 将错误行ID加入错误行数组中
          errorRowList.value.push(mc?.businessId);
        }
      }
      newTableData.push(mergedItem);
    }
    // 一次性更新响应式数据
    tableData.value = newTableData;
    data.loading = false;
    emits('update:loading', data.loading);
    if (computeInfoRows?.length) {
      pollComputedStatus(computeInfoRows);
    }
    isInitLoadData.value = true;
    clickMoreLoading.value = false;
  } catch (error) {
    console.error('获取分组数据失败:', error);
    data.loading = false;
    emits('update:loading', data.loading);
  }
};

// 辅助函数：创建占位符
const createPlaceholder = (item) => ({
  groupKey: item.groupKey,
  gk1: item.gk1,
  gk2: item.gk2,
  gk3: item.gk3,
  _uniqueId: `row-${generateUniqueId()}`,
  textPlaceholder: '该行数据不存在',
  isEmpty: true
});
/**************************列表初始化获取数据逻辑 E****************************** */
// 手动触发单条数据状态更新
const getComputedStatus = async (businessIdList) => {
  try {
    // 获取计算状态
    const computedInfo = await getComputedErrorLog(businessIdList);
    // 更新表格数据
    tableData.value = tableData.value.map((item) => {
      if (businessIdList.includes(item.id)) {
        // 如果返回空数组或者找不到对应的计算信息，说明已经计算完成
        if (!Array.isArray(computedInfo) || computedInfo.length === 0) {
          return { ...item, computedInfo: null };
        }
        // 查找当前id对应的计算信息
        const currentComputedInfo = computedInfo.find((info) => info.businessId === item.id);
        return {
          ...item,
          computedInfo: currentComputedInfo || null
        };
      }
      return item;
    });

    // 更新错误行列表
    errorRowList.value = errorRowList.value.filter((id) => !businessIdList.includes(id));
    if (Array.isArray(computedInfo)) {
      computedInfo.forEach((item) => {
        if (!computingStatus.includes(item.status)) {
          errorRowList.value.push(item.businessId);
        }
      });
    }

    // 更新可选择的数据ID列表
    // 如果businessIdList中的数据都没有计算错误或者返回空数组，将它们添加到allIds中
    const hasComputingData = Array.isArray(computedInfo) && computedInfo.some((item) => computingStatus.includes(item.status));
    if (!hasComputingData || !Array.isArray(computedInfo) || computedInfo.length === 0) {
      const curDataGroupKey = tableData.value.find((v) => v.id == businessIdList[0])?.[`gk${groupCount.value}`];
      if (curDataGroupKey && groupChecked.value[curDataGroupKey]) {
        groupChecked.value[curDataGroupKey].dataIds.push(businessIdList[0]);
        updateGroupCheckStatus(curDataGroupKey);
      }
    }

    // 如果数据计算完成，动态更新表格数据
    // 处理中的数据
    const processingIds = computedInfo.filter((v) => [1, 3].includes(v.status)).map((v) => v.businessId); // 还在处理中的数据
    const completedIds = businessIdList.filter((v) => !processingIds.includes(v)); // 处理完的数据
    console.log('分组已完成数据33', completedIds, getNewTableData);
    if (completedIds.length) {
      // 刷新计算完成的数据
      tableData.value = await getNewTableData(completedIds, data.viewId || props.viewId, tableData.value);
    }
  } catch (error) {
    console.log('getComputedStatus error:', error);
  }
};
/*********************************分组的计算状态处理 S******************************** */
// 存储定时器引用
const timer = ref(null);
// 存储需要轮询的项（计算中的项）
const pollingItems = ref([]);
// 预创建缓存Map
const computedResultCache = new Map();
// 更新表格数据中的计算状态，参数computedResults为计算状态结果，currentPollingIds为当前轮询项ID列表
const updateComputedStatus = async (computedResults, currentPollingIds) => {
  // 创建计算结果映射
  const resultMap = new Map(computedResults.map((item) => [item.businessId, item]));
  let resultData;

  // 更新计算状态
  resultData = tableData.value.map((item) => {
    // 如果是分组数据，不处理计算状态
    if (item.level || item.computedInfo?.status == 2) return item;
    const computedInfo = resultMap.get(item.id) || null;
    return { ...item, computedInfo };
  });

  // 处理中数据 id
  const processIngIds = computedResults.filter((v) => computingStatus.includes(v.status)).map((v) => v.businessId);
  // 处理完成数据 id
  const completedIds = currentPollingIds.filter((v) => !processIngIds.includes(v));

  console.log('分组已完成数据', completedIds);

  // 存在已完成的数据，去更新数据
  if (completedIds.length) {
    resultData = await getNewTableData(completedIds, data.viewId || props.viewId, resultData);
    return resultData;
  }

  return resultData;
};
// 处理计算结果并更新状态，参数computedResults为接口返回的计算结果
const processComputedResults = (computedResults) => {
  const computingIds = new Set();
  let allCompleted = true;
  // 处理每个计算结果
  computedResults.forEach((result) => {
    if (!result?.businessId) return;
    // 缓存计算结果
    computedResultCache.set(result.businessId, result);
    if (result.status === 1) {
      // 仍在计算中
      computingIds.add(result.businessId);
      allCompleted = false;
    } else if (result.status === 2) {
      // 计算失败，添加到错误列表
      errorRowList.value.push(result.businessId);
    }
  });
  return { allCompleted, computingIds };
};
// 更新分组选择状态，参数computingIds为正在计算的ID集合
const updateGroupChecked = (computingIds) => {
  console.log('groupCount.value', groupCount.value, groupChecked.value);

  for (const item of tableData.value) {
    if (!item.level) continue;
    // 只处理最里层的分组（因为只有最内层的分组才会有数据ID集合）
    if (item.level === groupCount.value) {
      // 将计算中的id的数据ID从groupChecked.value[item.groupKey].dataIds中移除（计算中的数据不可选择）
      groupChecked.value[item.groupKey].dataIds = item.dataIds.filter((id) => !computingIds.has(id));
      updateGroupCheckStatus(item.groupKey); //更新分组全选半选状态
    }
  }
};

// 执行轮询任务
const executePolling = async () => {
  try {
    // 获取当前需要轮询的ID（全部当前轮询项）
    const currentPollingIds = pollingItems.value.map((item) => item.id).filter(Boolean);
    // 如果没有需要轮询的ID，停止轮询
    if (currentPollingIds.length === 0) {
      stopPolling();
      return;
    }
    // 获取计算状态
    const computedResults = await getComputedErrorLog(currentPollingIds);
    // 创建返回结果ID集合
    const returnedIds = new Set(computedResults.map((r) => r.businessId));
    // 处理未返回的ID（表示计算成功）
    currentPollingIds.forEach((id) => {
      if (!returnedIds.has(id)) {
        // 对于计算成功的项，我们设置一个虚拟的成功状态对象
        computedResults.push({
          businessId: id,
          status: 0 // 假设0表示成功
        });
      }
    });
    // 处理计算结果
    const { allCompleted, computingIds } = processComputedResults(computedResults);
    // 更新表格数据
    tableData.value = await updateComputedStatus(computedResults, currentPollingIds);
    // 更新分组选择状态
    updateGroupChecked(computingIds);
    // 更新轮询项列表
    const stillComputingItems = [];
    for (const item of pollingItems.value) {
      const result = computedResults.find((r) => r.businessId === item.id);
      const updatedItem = result ? { ...item, computedInfo: result } : item;
      if (computingStatus.includes(updatedItem.computedInfo?.status)) {
        stillComputingItems.push(updatedItem);
      }
    }
    // 只需要保留仍在计算的项：
    pollingItems.value = stillComputingItems;
    // 如果全部完成，停止轮询
    if (allCompleted || pollingItems.value.length === 0) {
      stopPolling();
    }
  } catch (error) {
    console.error('轮询计算状态出错:', error);
    stopPolling();
  }
};

//  停止轮询
const stopPolling = () => {
  if (timer.value) {
    clearInterval(timer.value);
    timer.value = null;
  }
  pollingItems.value = [];
};
// 启动或继续轮询计算状态
const pollComputedStatus = async (newItems = []) => {
  // 参数newItems为新增的需要检查计算状态的项
  // 合并新项和当前正在轮询的项
  const mergedItems = [...pollingItems.value, ...newItems];
  // 去重
  pollingItems.value = Array.from(new Map(mergedItems.map((item) => [item.id, item])).values());
  // 立即执行一次轮询
  await executePolling();
  // 如果还有需要轮询的项且定时器未启动，则启动定时器
  if (pollingItems.value.length > 0 && !timer.value) {
    timer.value = setInterval(executePolling, 30000);
  }
};
/*********************************分组的计算状态处理 S******************************** */

// 点击表头上更多图标
const headerColInfo = ref({});
const isIconSubForm = ref(false);
const headerColumn = ref({});
const qfTableHeaderMoreRef = ref(null);
const headerIconMore = async (params) => {
  const { e, col, isSubForm = false, position } = params;
  console.log('headerIconMore', position, params);
  e.stopPropagation();
  const rect = e.currentTarget.getBoundingClientRect();
  isIconSubForm.value = isSubForm;
  headerColumn.value = col;
  headerColInfo.value = {
    ...col,
    top: rect.top + window.scrollY + 25 + 'px',
    left: rect.left + window.scrollX - 263 + 'px'
  };
  data.showColOverlay = true;
  // 置空鼠标状态
  mouseDownStatus.value = false;
  mouseUpStatus.value = false;
  await nextTick(() => {
    qfTableHeaderMoreRef.value?.clickMoreIcon();
  });
};
const filterParams = ref({});
const filterFieldArray = ref([]);
//表格
const clickMoreLoading = ref(true); // 点击更多按钮loading
const fieldSearchParams = ref(null);

// 高级筛选组件的回调事件
const getSearchData = async (v, searchType) => {
  // 线索池特殊处理--存储线索池id
  if (searchType == 'fieldSearch') {
    // 关键字搜索特殊逻辑
    console.log('fieldSearch', v);
    tableData.value = [];
    data.loading = true;
    emits('update:loading', data.loading);
    fieldSearchParams.value = v?.searchFields;
  }
  // 重置listPage接口参数
  if (entity.value == 101 && v?.sceneId) {
    poolId.value = v?.sceneId;
  }
  if (!useFilterList?.isFirst) {
    data.ruleForm.conditions = v?.conditions || [];
  } else {
    data.ruleForm.conditions = useFilterList?.conditionsList;
  }
  if (v.type && !useFilterList?.isFirst) {
    // 保存筛选数据
    await useFilterList.setConditionsList({ entity: entity.value, conditions: v?.conditions });
  }
  delete v.type;
  // 更新筛选条件的值，导出组件使用
  const params = {
    viewId: data.viewId,
    filterParams: {
      conditions: useFilterList?.isFirst ? data.ruleForm.conditions : v?.conditions,
      sceneType: v.sceneType,
      sceneId: v.sceneId,
      searchFields: fieldSearchParams.value
    }
  };
  keywords.value = fieldSearchParams.value?.value; // 关键字赋值
  searchFieldsList.value = fieldSearchParams.value?.field.map((vItem) => {
    if (vItem.subField) {
      return vItem.subField;
    }
    return vItem.field;
  });
  // 处理排序设置
  if (useFilterList?.fieldsSort?.length) {
    params.filterParams.sortSettings = useFilterList.fieldsSort.reduce((acc, item) => {
      if (item.fieldStatus == 1) {
        acc.push({
          ...item,
          sort: item.fieldSort
        });
      }
      return acc;
    }, []);
  }
  highFilterParams.value = params.filterParams;
  filterFieldArray.value = extractFields(params.filterParams.conditions); //处理筛选字段
  emits('cb', params);
  selectTableIds.value = [];
  // 如果初始化有排序字段，则需要手动添加到字段列表中
  if (useFilterList?.fieldsSort?.length) {
    addFieldsSort(); //更新表头筛选图标状态
  }
  if (!useFilterList?.isFirst) {
    await getGroupStructureInfo();
    /* 首次加载在高级筛选已获取过，不用初次调取，后续每次条件更新都需要同步获取最新条件 */
    await useFilterList.getConditionsList({ entity: entity.value }); // 存储筛选条件
    data.ruleForm.conditions = useFilterList?.conditionsList;
  }
  useFilterList.setIsFirst(false);
  clickMoreLoading.value = false;
};
// 表头单字段筛选参数
const getConditionParams = (params) => {
  console.log('getConditionParams', params);
  if (params.type) {
    getSearchData({ ...params, type: true });
  }
};
const tableScrollToTop = (params) => {
  fhTableRef.value?.scrollToTop(params);
};
// 如果需要列选择，就需要在自己需要的地方自定义一个按钮，实现table的这个事件 开始 S
const fhTableRef = ref(null); // 表格ref

const ids = ref([]);
const selectTableIds = ref([]); //选择的数据ID
// 快捷组件中按钮的回调
const shortcutBtnCb = (params) => {
  if (params === 'cancel') return;
  if (params?.type === 'refreshRow') {
    selectTableIds.value = selectTableIds.value.filter((v) => v !== params.id);
  }
  refreshList();
};
// 追加排序字段
const addFieldsSort = () => {
  if (data.columns?.length) {
    data.columns?.forEach((item) => {
      const obj = fieldsSort.value?.find((e) => {
        return e.fieldKey == item.colKey;
      });
      if (obj) {
        if (obj.fieldSort === true || obj.fieldSort === false) {
          item.fieldSort = obj.fieldSort;
        } else {
          item.fieldSort = '';
        }
      } else {
        item.fieldSort = '';
      }
    });
  }
};
// 获取表格表头字段
const getField = async (viewId) => {
  data.viewId = viewId?.viewId || props.viewId;
  // 缓存字段数据 (避免多次访问响应式对象)
  data.fieldList = useTableInfo.columnFieldList; // 列表字段
  // 如果初始化有高级筛选，则需要手动添加到字段列表中
  if (useFilterList?.conditionsList?.length) {
    data.ruleForm.conditions = useFilterList?.conditionsList; // 筛选条件
    filterFieldArray.value = extractFields(data.ruleForm.conditions); //处理筛选字段
  }
  // 列配置计算
  data.columns = getColumns();
  // 如果初始化有排序字段，则需要手动添加到字段列表中
  if (useFilterList?.fieldsSort?.length) {
    // console.log(123456789, 11111, useFilterList?.fieldsSort);
    addFieldsSort();
  }
};

// 排序  sort.isDefault == true  恢复默认  sort.isNull == true  清空所有
const sortChange = async (sort = null) => {
  // 默认排序
  if (typeof sort === 'object' && sort !== null) {
    if (sort.isDefault == true) {
      filterParams.value.sortSettings = useFilterList?.fieldsSortDefault?.length ? useFilterList?.fieldsSortDefault : [];
    }
    if (sort.isNull == true) {
      filterParams.value.sortSettings = [];
    }
  } else {
    // 自定义排序
    filterParams.value.sortSettings = useFilterList?.fieldsSort?.length ? useFilterList?.fieldsSort : [];
  }
  // 过滤掉 停用字段
  if (filterParams.value.sortSettings && filterParams.value.sortSettings?.length) {
    filterParams.value.sortSettings = filterParams.value.sortSettings?.filter((item) => item.fieldStatus != 2);
    // 添加 sort 与 fieldSort
    filterParams.value.sortSettings = filterParams.value?.sortSettings.map((item) => {
      item.sort = item.fieldSort;
      // delete item.fieldSort;
      return item;
    });
  }
  selectTableIds.value = [];
  showLay(false);
  addFieldsSort();
  await getGroupStructureInfo();
};
// 标题冻结列
const colTitleFrozen = (key, value, newColumns) => {
  // 创建一个新的数组，避免直接修改原始数据
  const updatedColumns = newColumns?.map((item) => ({ ...item }));
  console.log(834, key, value, newColumns, updatedColumns, 'updatedColumns');
  // 分别筛选出左固定、右固定和非固定的列
  const fixedLeft = updatedColumns?.filter((item) => item.fixed === 'left' && item.colKey !== key);
  const fixedRight = updatedColumns?.filter((item) => item.fixed === 'right' && item.colKey !== key);
  const noFixed = updatedColumns?.filter((item) => !item.fixed && item.colKey !== key);
  // 找到当前列
  const current = updatedColumns?.find((item) => item.colKey === key);
  console.log(882, current);
  // 根据 value 来设置当前列的 fixed 属性
  if (value) {
    current.fixed = 'left';
    fixedLeft.push(current); // 将当前列放入左固定数组
  } else {
    current.fixed = undefined;
    noFixed.unshift(current); // 将当前列放入非固定数组的开头
  }
  // 组合新的列数组，确保顺序为左固定 -> 非固定 -> 右固定
  const newList = [...fixedLeft, ...noFixed, ...fixedRight];
  // data.columns = newList;
  // 假设 fhTableRef.value.getCols(newList) 可以正确处理顺序问题
  console.log('colTitleFrozen-newList', fhTableRef);
  fhTableRef.value.getCols(newList);
  console.log(847, newList);
  showLay(false);
};
// 从所有字段中获取表格头部标题
const getColumns = () => {
  const list = [];
  data.fieldList?.forEach((item) => {
    const colConfig = createColumnConfig(item, {
      tableData: tableData,
      entity: entity.value,
      tableLevel: 0,
      virtual: true
    });
    if (item?.fieldType == 27) {
      colConfig.children = createChildColumns(item, {
        tableData: tableData,
        entity: entity.value,
        tableLevel: 0,
        virtual: true
      });
    }
    list.push(colConfig);
  });
  return list;
};

// 是否显示按钮组件
const shouldShowButtonGroup = computed(() => {
  const hasSelection = selectTableIds.value?.length;
  const hasShortcut = props.shortcutBtnPermission?.length;
  const hasBatch = props.batchBtnPermission?.length;
  // 没有任何按钮配置时，永远不显示
  if (!hasSelection || (!hasShortcut && !hasBatch)) return false;
  // 有选择时才进一步判断
  if (hasSelection === 1 && !hasShortcut) return false;
  if (hasSelection > 1 && !hasBatch) return false;
  return true;
});

const shouldShowShortcutBtn = computed(() => {
  const isSingleSelect = selectTableIds.value?.length === 1;
  const hasShortcut = props.shortcutBtnPermission?.length > 0;
  // 仅当单选且配置了快捷按钮时显示
  return isSingleSelect && hasShortcut;
});

const shouldShowBatchBtn = computed(() => {
  const isMultiSelect = selectTableIds.value?.length > 1;
  const hasBatch = props.batchBtnPermission?.length > 0;
  // 仅当多选且配置了批量按钮时显示
  return isMultiSelect && hasBatch;
});
// 获取标题显示名称
const getDisplayName = (row) => {
  if (row.fieldType === 6 && row?.business?.userName) {
    return row.business.userName;
  }
  if (row.fieldType === 12 && row?.business?.label) {
    return row.business.label;
  }
  if (row.fieldType === 22 && row?.business?.name) {
    return row.business.name;
  }
  return row.name;
};

const handleMouseDown = () => {
  mouseDownStatus.value = true;
  console.log('mousedown-mousedown 事件触发');
};
const handleMouseUp = () => {
  mouseUpStatus.value = true;
  if (mouseDownStatus.value && mouseUpStatus.value) {
    showLay(false);
  }
};

// 遮罩层
const showLay = async (val) => {
  if (!val && qfTableHeaderMoreRef.value) {
    qfTableHeaderMoreRef.value.closedOverLay();
  }
  await nextTick();
  data.showColOverlay = val;
};
// 清除选中
const clearSelected = () => {
  ids.value = [];
  selectTableIds.value = [];
  // 清空分组标题的选中
  Object.values(groupChecked.value).forEach((item) => {
    item.checked = false;
    item.indeterminate = false;
  });
};
//重置刷新列表
const batchBtnCb = async () => {
  ids.value = [];
  selectTableIds.value = [];
  await getGroupStructureInfo();
};

watch(
  () => useFilterList?.fieldsSort,
  (v) => {
    fieldsSort.value = v;
  },
  {
    deep: true,
    immediate: true
  }
);

const currentNewColumns = ref([]); //实时更新列宽显示
// 列宽拖拽实时获取列宽
const columnResize = (record, showCol) => {
  console.log('columnResize', record, showCol);
  currentNewColumns.value = showCol; //实时更新列宽显示
  console.log(1085, record, showCol);
};
// 表格行滚动事件-->参数：params：{ direction: 'left' | 'right' | 'top' | 'bottom'， distance: number, distance: number }，direction：滚动方向，distance：滚动距离
const tableScrollEvent = async (params) => {
  //例如： params = { direction: 'left', distance: 100 };
  console.log('tableScrollEvent', params);
  if (fhTableRef.value) {
    fhTableRef.value?.tableScrollEvent(params);
  }
};
// 获取左侧固定列最后一列到视口左侧的距离
const getFixedLeftLastCellRect = (level = 1) => {
  return fhTableRef.value?.getFixedLeftLastCellRect(level);
};

// 获取Qf-table的表体实例方法
const getTableBodyRef = (level = 1) => {
  return document.querySelectorAll('.qf-table-body')?.[level - 1];
  //return fhTableRef.value?.getTableBodyRef(level);
};
// 获取表格滚动容器的实例方法
const getScrollContainerRef = (level = 1) => {
  return fhTableRef.value?.getScrollContainerRef(level);
};
// 获取Qf-table的表头实例方法
const getTableHeaderRef = (level = 1) => {
  return fhTableRef.value?.getTableHeaderRef(level);
};
// 提供修改行数据的z-index方法
const updateZIndex = ({ rowKey, zIndex }) => {
  if (!fhTableRef.value) return;
  fhTableRef.value?.updateZIndex({ rowKey, zIndex });
};

// 在此处调用初始化获取分组接口，此接口是根据dataIds集合参数获取数据的，属于默认调用，初始化时后端默认返回第一页所有数据，比如每一页20条数据，则返回20条数据，前端根据dataIds集合参数，判断是否还有下一页，如果有则继续调用接口获取下一页数据，直到dataIds集合参数为空，则停止调用接口
// 之所以是暂存，是因为loadGroupData方法在滚动时会不断触发，所以groupGroupInfo对象中的数据会越来越多，所以需要写一个方法，如果1000ms内groupGroupInfo对象中的数据没有变化（只用判断对象的键是否变化即可），如果1000ms内groupGroupInfo对象中的数据没有变化，则开始调用接口，调用接口也有逻辑判断，需要从groupGroupInfo对象中倒序查找dataIds,最多向上查找10个分组或者当准备的新loadMoreIds集合已经达到60个数据时（这些id就是从每一组的dataIds中取的值），则开始调用接口同时清空groupGroupInfo对象中的数据
//groupGroupInfo为暂存的分组数据，以分组的groupKey为键，以dataIds集合为值的键值对对象，用于存储即将调用的分组的dataIds集合
const groupGroupInfo = new Map();
// 定时器引用（存储定时器ID和创建时间戳）
const groupInfoTimer = ref(null);
// 是否正在加载数据（强化状态锁）
const isLoading = ref(false);
const isInitLoad = ref(true);
// 分组加载触发事件
const loadGroupData = (params) => {
  console.log(120000, '触发加载:', params);
  // 如果 Map 中已有该 groupKey，先删除旧的
  if (groupGroupInfo.has(params.groupKey)) {
    groupGroupInfo.delete(params.groupKey);
  }
  // 重新设置该键值对（会自动插入到 Map 的末尾）
  groupGroupInfo.set(params.groupKey, params.dataIds);
  // 清除旧定时器
  if (groupInfoTimer.value) {
    clearTimeout(groupInfoTimer.value);
  }
  const delay = isInitLoad.value ? 0 : 800;
  groupInfoTimer.value = setTimeout(() => {
    if (!isLoading.value) {
      prepareAndLoadData();
    }
  }, delay);
};

// 准备并加载数据（核心逻辑）
const prepareAndLoadData = async () => {
  console.log(12000, 'prepareAndLoadData开始执行了', isLoading.value, groupGroupInfo, groupInfoTimer.value);
  if (isLoading.value) return;
  isLoading.value = true;
  try {
    // 使用entries() 方法（返回迭代器，需转为数组）
    const groupEntries = Array.from(groupGroupInfo.entries());
    const totalGroups = groupEntries.length;
    if (totalGroups === 0) return;
    // 倒序取最多15组（最新添加的优先）
    const maxGroups = 15;
    const candidateGroups = [];
    for (let i = totalGroups - 1; i >= Math.max(0, totalGroups - maxGroups); i--) {
      candidateGroups.push(groupEntries[i]);
    }
    // 从候选组中筛选不超过120条id的整组（严格整组处理）
    const maxIds = 200;
    const selectedGroups = [];
    let totalIds = 0;
    for (const [groupKey, dataIds] of candidateGroups) {
      const idsCount = dataIds?.length || 0;
      // 若加入该组会超过200条，则跳过（不拆分组）
      if (totalIds + idsCount > maxIds) {
        break;
      }
      selectedGroups.push({ groupKey, dataIds });
      totalIds += idsCount;
    }
    if (selectedGroups.length === 0) return;
    // 执行接口调用
    const loadMoreIds = selectedGroups.flatMap(({ dataIds }) => dataIds);
    await getGroupTableData(loadMoreIds);
    isInitLoad.value = false;
    // 清除已处理的分组（Map 使用 delete 方法）
    selectedGroups.forEach(({ groupKey }) => {
      const gvg = groupChecked.value[groupKey];
      console.log(12000, '准备并加载数据:', gvg, groupChecked.value);
      if (gvg && gvg?.dataIds?.length) {
        gvg.disabled = false;
      }
      groupGroupInfo.delete(groupKey);
    });
  } catch (error) {
    console.error('加载数据失败:', error);
  } finally {
    isLoading.value = false;
  }
};
// 点击加载更多说去数据接口调用
const getTableDataListPageClickV2 = async (gp) => {
  try {
    const params = {
      entity: entity.value,
      id: data.viewId || props.viewId,
      page: props?.viewsObj?.viewClass == '30' ? gp.page + 1 : gp.page == 1 ? gp.page + 2 : gp.page + 1,
      pageSize: props?.viewsObj?.viewClass == '30' ? 20 : 50,
      groupQuery: gp.groupQuery,
      ...highFilterParams.value,
      ...filterParams.value
    };
    // 声明一个数组，用于存储行信息中存在computeInfo的行信息
    const computeInfoRows = [];
    const tableDataValue = [...tableData.value]; // 提前获取当前数据快照
    // 并行处理：发起请求同时准备查找索引
    const [json, findIndexes] = await Promise.all([
      tableService.getTableDataListPageClickV2(params),
      (() => {
        let groupIndex = -1;
        let moreIndex = -1;
        for (let i = 0; i < tableDataValue.length; i++) {
          const item = tableDataValue[i];
          if (item.uniqueMore === gp.uniqueMore) moreIndex = i;
          if (item.level && item.groupKey === gp.uniqueMore && groupIndex === -1) groupIndex = i;
          if (groupIndex !== -1 && moreIndex !== -1) break;
        }
        return { groupIndex, moreIndex };
      })()
    ]);
    const { result: res } = json || {};
    const { records: rrs } = res || {};
    if (!rrs?.length) {
      clickMoreLoading.value = false;
      return;
    }
    // 准备新数据 - 使用更高效的方式
    const currentItemDataIds = tableDataValue[findIndexes.groupIndex]?.dataIds || [];
    const newIds = new Set(); // 使用Set存储新ID，便于快速查找
    const newData = rrs.map((item, index) => {
      const newItem = {
        gk1: gp.gk1,
        gk2: gp.gk2,
        gk3: gp.gk3,
        hasData: true,
        _uniqueId: `id-${Math.random().toString(36).substring(2, 9)}`,
        rowIndex: currentItemDataIds.length + index,
        ...item
      };
      // 收集接口返回的数据中存在computeInfo的行status：1计算中2：计算错误
      const mc = newItem.computedInfo;
      if (mc) {
        if (computingStatus.includes(mc.status)) {
          computeInfoRows.push(newItem);
        } else {
          // 将错误行ID加入错误行数组中
          errorRowList.value.push(mc?.businessId);
        }
      }
      newIds.add(item.id);
      return newItem;
    });
    // 如果有更多数据，添加加载更多行
    if (res.current < res.pages) {
      newData.push({ ...gp, page: res.current });
    }
    // 批量更新数据
    if (findIndexes.moreIndex !== -1) {
      tableDataValue.splice(findIndexes.moreIndex, 1, ...newData);
    } else {
      tableDataValue.push(...newData);
    }
    // 更新分组数据 - 使用展开运算符避免多次push
    if (tableDataValue[findIndexes.groupIndex]) {
      tableDataValue[findIndexes.groupIndex].dataIds = [...currentItemDataIds, ...newIds];
    }
    // 更新分组复选框数据
    if (groupChecked.value[gp.uniqueMore]) {
      groupChecked.value[gp.uniqueMore].dataIds = [...(groupChecked.value[gp.uniqueMore].dataIds || []), ...newIds];
      updateGroupCheckStatus(gp.uniqueMore);
    }
    // 使用微任务批量更新
    queueMicrotask(() => {
      tableData.value = tableDataValue;
      clickMoreLoading.value = false;
      // 如果有计算行，调用pollComputedStatus
      if (computeInfoRows?.length) {
        pollComputedStatus(computeInfoRows);
      }
    });
  } catch (error) {
    console.error('加载更多数据失败:', error);
    clickMoreLoading.value = false;
  }
};
// 点击加载更多事件
const loadMoreGroupData = async (gk) => {
  // 点击加载更多，用户手动触发主动调用，这个接口是获取更多数据的，属于主动调用，此时需要传递各种参数，比如高级筛选、分组条件、排序条件、分页参数等
  clickMoreLoading.value = true;
  await getTableDataListPageClickV2(gk);
  console.log(123456, '加载更多分组数据', gk);
};

provide('defaultParams', {
  id: computed(() => data.id),
  entity: computed(() => entity.value),
  viewId: computed(() => data.viewId), //兼容多层级表格
  poolId: computed(() => poolId.value),
  columns: computed(() => (currentNewColumns.value?.length ? currentNewColumns.value : data.columns)),
  keywords: computed(() => keywords.value), // 搜索值
  searchFieldsList: computed(() => searchFieldsList.value) // 搜索字段
});
provide('tableMethods', {
  tableScrollEvent: tableScrollEvent,
  getFixedLeftLastCellRect: getFixedLeftLastCellRect,
  updateZIndex: updateZIndex
});
provide('mainTableMethods', {
  getTableBodyRef: getTableBodyRef,
  getTableHeaderRef: getTableHeaderRef,
  tableScrollToTop: tableScrollToTop,
  toDetails: toDetails,
  getScrollContainerRef: getScrollContainerRef
});
// groupAllStateObj为分组中报错分组展开和折叠状态，需要与分组状态保持一致
provide('groupState', {
  groupState: groupAllStateObj,
  createGroupMap: computed(() => createGroupMap)
});

// 在此处调用分组展开和收起接口，根据params参数判断是展开还是收起，并更新分组数据
const foldOrUnfold = (v) => {
  console.log(123456, '分组展开和收起', v, groupAllStateObj.value);
  for (const key in groupAllStateObj.value) {
    groupAllStateObj.value[key] = v; // 更新分组状态
  }
  // 分组重新计算行高事件，当分组出现展开/收起时，会触发该事件
  fhTableRef.value?.scrollToTop();
};
// 刷新列表
const refreshList = async (tp) => {
  if (tp === 'detail') {
    console.log(966, '详情刷新了', tp, data.id);
    getGroupTableData([data.id]);
    // await getGroupStructureInfo(); //刷新列表
  } else {
    data.loading = true;
    emits('update:loading', data.loading);
    selectTableIds.value = [];
    // tableData.value = [];
    await getGroupStructureInfo();
  }
};
// 公共按钮组件事件回调
const universalRefreshList = async () => {
  data.loading = true;
  emits('update:loading', data.loading);
  selectTableIds.value = [];
  await getGroupStructureInfo();
};
const getLoadTableList = async function () {
  if (useLayout?.changeViewId?.[entity.value]) {
    data.viewId = useLayout?.changeViewId?.[entity.value];
    selectTableIds.value = [];
    getField(data.viewId);
  }
  getGroupStructureInfo();
};
// 完整 onMounted 逻辑
onMounted(async () => {
  // 当 getFieldAndNestInfo 完成时立即触发 getField,提前渲染表头信息
  const fieldInfoPromise = useTableInfo.getFieldAndNestInfo({ entity: entity.value, viewId: props.viewId || null });
  fieldInfoPromise.then(() => {
    getField(props.viewsObj);
  });
  // 进入分组同时要调用两个接口：一个是表头信息一个、是拿分组结构，组装组数据，同时生成数据ID集合，用于后续接口获取数据
  await Promise.all([fieldInfoPromise, getGroupStructureInfo()]);
  isInitLoad.value = false; // 初始化完成后，关闭loading
});
watch(
  () => isInitLoadData.value,
  (v) => {
    // 控制调用高级筛选组件的时机，保证先获取表头和表格数据再调用高级筛选组件
    if (v) emits('loadAdvancedComp', true);
  },
  { immediate: true }
);
onBeforeUnmount(() => {
  console.log(1589, 'fh-layout-unmount', '表格组件卸载了');
  if (timer.value) {
    clearInterval(timer.value);
    timer.value = null;
  }
  if (groupInfoTimer.value) {
    clearTimeout(groupInfoTimer.value);
    groupInfoTimer.value = null;
  }
  data.columns = [];
  tableData.value = [];
  selectTableIds.value = [];
  data.fieldList = [];
  data.ruleForm.conditions = [];
  // 清理 DOM 引用
  fhTableRef.value = null;
  detailRef.value = null;
  qfTableHeaderMoreRef.value = null;
  // 清理缓存
  provide('mainTableMethods', null);
  provide('tableMethods', null);
  provide('defaultParams', null);
});
// 确保所有定时器都被清理
onUnmounted(() => {
  if (timer.value) {
    clearInterval(timer.value);
    timer.value = null;
  }
});
defineExpose({ getField, toDetails, universalRefreshList, getLoadTableList, openColSelect, refreshList, sortChange, getSearchData, openDashboardFieldSettingModal });
</script>
<style scoped lang="less">
@import './fh-main-table-group.less';
</style>
